import { Pipe, PipeTransform, inject } from '@angular/core';
import { Mobility } from '@moxi.gmbh/moxi-typescriptmodels';
import { TranslateService } from '@ngx-translate/core';
import { mobilityTypes as mobTypes } from '@shared/models';

@Pipe({
  name: 'mobilityName',
  standalone: true
})
export class MobilityNamePipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);

  transform(value: Mobility): unknown {
    const mobility = mobTypes.find(mInfo => mInfo.id === value)?.name;

    return mobility ? this.translateService.instant(mobility) : value;
  }
}
